import { render, staticRenderFns } from "./AiTaskChat.vue?vue&type=template&id=cc4a79b4&scoped=true"
import script from "./AiTaskChat.vue?vue&type=script&lang=js"
export * from "./AiTaskChat.vue?vue&type=script&lang=js"
import style0 from "./AiTaskChat.vue?vue&type=style&index=0&id=cc4a79b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4a79b4",
  null
  
)

export default component.exports